/**
 * Updates the reaction for a specific imageId in a nested structure of ideas and images.
 * @param {Array} ideas - The original array of idea objects.
 * @param {string} imageId - The ID of the image to update.
 * @param {string|null} newReaction - The new reaction value
 * @param {string} updatedOn - The date and time the reaction was updated
 * @returns {Array} A new array with the updated reaction applied immutably.
 */
const updateReactionByImageId = (ideas, imageId, newReaction, updatedOn) =>
  ideas.map((idea) => ({
    ...idea,
    images: idea.images.map((img) => (img.id === imageId ? { ...img, reaction: newReaction, updatedOn } : img)),
  }));

export default updateReactionByImageId;
